import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import useFormattedDate from 'hooks/useFormattedDate';
import useDaysBefore from 'hooks/useDaysBefore';
import ProjectInfoPanel from 'components/ProjectInfoPanel/ProjectInfoPanel';

export interface DaysLeftProps {
  closeDate: string;
}

const DaysLeft: FC<DaysLeftProps> = ({ closeDate }) => {
  const { t } = useTranslation();
  const formattedCloseDate = useFormattedDate(closeDate, 'dd-MMM-y');
  const daysLeft = useDaysBefore(closeDate);

  return (
    <div className="days-left">
      <ProjectInfoPanel
        variant="kliparo"
        className="close-date"
        label={t('pages.projectOverview.sidePanel.assessmentCloseDate')}
        value={formattedCloseDate}
      />
      <ProjectInfoPanel
        className="days-left-count"
        label={t('pages.projectOverview.sidePanel.daysRemaining')}
        value={daysLeft}
        withBorder
      />
    </div>
  );
};

export default DaysLeft;
